import { Card, Layout } from "element-react";
import { Link } from "react-router-dom";
import aboutUsImg from "../assets/imgs/about-us-default.png";
import StarFilledIcon from "./StarFilledIcon";
import { toCurrency } from "../utils/FormatUtils";
import ChatIcon from "./ChatIcon";
import { S3Image } from "../components/S3Image";
import { countryOptions } from '../utils/Catalogs';
import ProductIconClean from './order/ProductIconClean';

import VerifiedBadge from '../components/VerifiedBadge';

const ResultCard = (props) => {
  const prd = props.product;
  const favorites = props.favorites;
  const t = props.t;
  const addToFavorites = props.addToFavorites;
  const removeFromFavorites = props.removeFromFavorites;

  const isFav = () => {
    let result = favorites.filter((obj) => {
      return obj.product.id === prd.id;
    });
    return result.length > 0 ? result[0] : undefined;
  };

  // --- LÓGICA DE UBICACIÓN ---
  const getLocationString = () => {
      // Usar el objeto nuevo 'company.address' si existe
      if (prd.company && prd.company.address) {
          const { state, country } = prd.company.address;
          const parts = [];
          if (country) parts.push(country); 
          if (state) parts.push(state);
          if (parts.length > 0) return parts.join(", ");
      }

      // si falla el objeto company
      const parts = [];
      if (prd.company_state) parts.push(prd.company_state);
      if (prd.company_country) {
          const found = countryOptions.options.find(c => c.value === prd.company_country);
          parts.push(found ? found.label : prd.company_country);
      }
      return parts.join(", ");
  };

  const locationString = getLocationString();

  // --- LÓGICA DE CERTIFICADO ---
  const certificationString = prd.company?.titles || prd.titles || "N/A";

  const storeUrl = "/company-store/" + 
      (prd.company_name || "").replace(/\//g, "").replace(/\s+/g, "-").toUpperCase() + 
      "/" + prd.company_id;

  return (
    <>
      <Card className="result-card-style">
        <Layout.Row>
          {/* COLUMNA IZQUIERDA: FOTO */}
          <Link id="ga_view_product_picture" target="_blank" to={"/product-detail/" + prd.id}>
            <Layout.Col className="center-card-img-prd" sm="24" md="10" lg="5">
              {prd && prd.photo && prd.photo.length > 0 ? (
                <S3Image
                  className="special-container"
                  imgKey={prd.photo[0].key}
                  theme={{ photoImg: { width: "100%" } }}
                  level="public"
                />
              ) : (
                <img
                  className="special-container__image"
                  src={aboutUsImg}
                  style={{ width: "200px", height: "200px" }}
                  alt="Product"
                />
              )}
            </Layout.Col>
          </Link>
          
          {/* COLUMNA DERECHA: DATOS */}
          <Layout.Col sm="24" md="10" lg="19">
            
            {/* 1. NOMBRE DEL PRODUCTO */}
            <Layout.Row className="row-result-product-name">
              <Link
                id="ga_view_product_link"
                className="result-product-name"
                target="_blank"
                to={"/product-detail/" + prd.id}
              >
                {prd.name}
              </Link>
            </Layout.Row>
            
            {/* 2. NOMBRE DE LA EMPRESA */}
            <Layout.Row type="flex" className="compact-row">
              <Layout.Col style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                
                <b className="result-by">{t("search.by")}:&nbsp;</b>
                
                <Link className="result-company" target="_blank" to={storeUrl} style={{ marginLeft: '4px', marginRight: '5px' }}>
                  {prd.company_name}
                </Link>

                {/* INSIGNIA — usa el campo is_verified devuelto por el buscador o consulta en tiempo real */}
                <VerifiedBadge companyId={prd.company_id} isVerified={prd.is_verified || prd.company?.is_verified} />
              </Layout.Col>
            </Layout.Row>

            {/* 3. CATEGORÍA */}
            <Layout.Row type="flex" className="compact-row">
              <Layout.Col>
                <span className="result-category">
                  {prd.category?.category_name 
                    ? prd.category.category_name + ' > ' + (prd.category?.name || "")
                    : (prd.subcategory_name || "General")
                  }
                </span>
              </Layout.Col>
            </Layout.Row>

            {/* 4. CERTIFICACIONES */}
            {certificationString && (
                <Layout.Row type="flex" className="compact-row">
                    <Layout.Col className="result-by" style={{fontSize: '16px', lineHeight: '1.5'}}>
                        <div><b style={{color: '#606060'}}>Certifications: </b>{certificationString}</div>
                    </Layout.Col>
                </Layout.Row>
            )}

            {/* 5. UBICACIÓN */}
            {locationString && (
                <Layout.Row type="flex" className="compact-row">
                    <Layout.Col>
                        <span className="result-country">
                            {locationString}
                        </span>
                    </Layout.Col>
                </Layout.Row>
            )}

            {/* 6. BADGES (Verified, Gold, etc.) - En su propia línea*/}
            <Layout.Row type="flex" className="compact-row">
                <Layout.Col>
                    <div className="result-info">
                        {/*{prd.verified === 1 && <span className="result-verified">Verified &nbsp;&nbsp;</span>}*/}
                        {prd.bainub_account_year && <span className="result-bainub-account-year">{prd.bainub_account_year}Y in Bainub&nbsp;&nbsp;</span>}
                        {prd.supplier_rating && <span className="result-supplier-rating">Gold Supplier&nbsp;&nbsp;</span>}
                        {prd.customizable === "true" && <span className="result-customizable">Customization Available</span>}
                    </div>
                </Layout.Col>
            </Layout.Row>

            {/* DATOS DE VENTA (Precio, Packing, Min Order) */}
            <Layout.Row type="flex" className="compact-row">
                  <Layout.Col className="result-by">
                      <b>{t("search.price-range")}</b>
                      {": "} <span>{toCurrency(prd.min_price)}</span> - <span>{toCurrency(prd.max_price)}</span> USD/
                      <span>{prd.measurement}</span>
                  </Layout.Col>
            </Layout.Row>
              
            <Layout.Row type="flex" className="compact-row">
                  <Layout.Col className="result-by">
                      <b>{t("search.packing")}:</b> {prd.package_type} {prd.quantity_per_package && <span>- {prd.quantity_per_package} {prd.measurement}s</span>}
                  </Layout.Col>
            </Layout.Row>

             <Layout.Row type="flex" className="compact-row">
                  <Layout.Col className="result-by">
                      <b>{t("search.min-order")}:</b> <span>{prd.min_order} {prd.measurement}</span>
                  </Layout.Col>
            </Layout.Row>
            
            <hr></hr>
            
            {/* FOOTER ACTIONS */}
            <Layout.Row className="result-card actions-result p-t-md" type="flex">
              <Layout.Col lg="5">
                <div style={{ display: "inline-flex", cursor: "pointer", paddingTop: "8px" }}>
                  <Link style={{ display: "inline-flex", cursor: "pointer" }} target="_blank" to={"/product-detail/" + prd.id}>
                  <ProductIconClean color="#FF6D73" width={24} height={24} />
                  <div style={{ paddingLeft: "8px" }} className="link-text">
                    {'View Product Details'}
                  </div>
                  </Link>
                </div>
              </Layout.Col>
              
              <Layout.Col lg="5">
                <div
                  style={{ display: "inline-flex", cursor: "pointer", paddingTop: "8px" }}
                  onClick={() => props.handleChatWithUs(prd.owner, prd)}
                >
                  <ChatIcon color="#FF6D73" width={18} height={18} />
                  <div id="ga_contact_supplier" style={{ paddingLeft: "8px" }} className="link-text">
                    {" "}{t("search.contact-supplier")}
                  </div>
                </div>
              </Layout.Col>
              
              <Layout.Col className="cursor" style={{ textAlign: "left" }} lg="8">
                <div id="ga_add_favorites" style={{ display: "inline-flex", paddingTop: "8px" }}>
                  <StarFilledIcon width={18} height={18} />
                  {isFav() ? (
                    <div className="link-text" onClick={() => removeFromFavorites(isFav())}>
                      {" "}{t("search.remove-to-list")}
                    </div>
                  ) : (
                    <div className="link-text" onClick={() => addToFavorites(prd.id)}>
                      {" "}{t("search.add-to-list")}
                    </div>
                  )}
                </div>
              </Layout.Col>
            </Layout.Row>
          </Layout.Col>
        </Layout.Row>
      </Card>
    </>
  );
};

export default ResultCard;